/*
  Authors : initappz (Rahul Jograna)
  Website : https://initappz.com/
  App Name : Grocery Delivery App Source code is licensed as per the
  terms found in the Website https://initappz.com/license
  Copyright and Good Faith Purchasers © 2024-present initappz.
*/
export const environment = {
  production: true,
  baseUrl: "https://api.freshveggiemart.com/public/api/",
  imageUrl: "https://api.freshveggiemart.com/public/storage/images/",
  firebase: {
    apiKey: "AIzaSyCRkRHUiaJGTFtVCRonbYPthJ4jXweZ5os",
    authDomain: "project-1ec9b1b4-7688-4849-be1.firebaseapp.com",
    projectId: "project-1ec9b1b4-7688-4849-be1",
    storageBucket: "project-1ec9b1b4-7688-4849-be1.firebasestorage.app",
    messagingSenderId: "894392877712",
    appId: "1:894392877712:web:2fc629c7cc46d55e7e4e15",
  },
};

